import React, { useContext } from 'react';
import ModalTemplate from '../Modals/_ModalTemplate';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import ExampleEADImage from '../../../assets/images/example-ead.png';

const RenderExample = () => {
  return (
    <>
      <p>
        Please see an example of an Export Accompanying Document (EAD).
        <br />
        The original PDF can be uploaded to populate the data in your ICS2 Consignment
      </p>
      <img src={ExampleEADImage} alt="Example Export Accompanying Document (EAD)" style={{ width: '100%' }} />
    </>
  );
};

const DocumentExampleModal = ({ isOpen, setIsOpen }) => {
  return (
    <ModalTemplate
      width={955}
      title="Export Accompanying Document (EAD) Example"
      body={<RenderExample />}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      buttons={
        <>
          <span></span>
          <Button variant="contained" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </>
      }
    />
  );
};

export default DocumentExampleModal;
